<app-logo-area [breadcrumbs]="[{'display': 'Content Platform', commands: ['/o', this.organization()?.id]}]"></app-logo-area>
<main>
  <app-headline-section [title]="'Audio Order'"></app-headline-section>
  <section class="cl-section cl-section-regular">
    <div id="audio-order-form" class="container cl-form" [formGroup]="poFormGroup">
      <div class="row">
        @if (airlines().length > 1) {
          <div class="col-4">
            <label for="airline" class="form-label">Airline<span class="required">*</span></label>
            <select id="airline" class="form-select" formControlName="airline" [class.invalid]="poFormGroup.controls.airline.invalid && (poFormGroup.controls.airline.touched || poFormGroup.controls.airline.dirty)">
              @for (airline of airlines(); track airline) {
                <option [value]="airline.iata_code"> {{ airline.airline_name }}
                  ({{ airline.iata_code }})
                </option>
              }
            </select>
            @if (poFormGroup.controls.airline.errors?.required) {
              <p class="invalid-feedback">This field is required.</p>
            }
            @if (!poFormGroup.controls.airline.errors) {
              <p class="valid-feedback">Selects the airline on Castlabs'
              side.</p>
            }
          </div>
        }


        <div [class.col-4]="airlines().length > 1" [class.col-8]="airlines().length === 1">
          <label for="po_number" class="form-label">PO Prefix<span class="required">*</span></label>
          <input id="po_number" type="text" formControlName="po_number" [class.invalid]="poFormGroup.controls.po_number.invalid && (poFormGroup.controls.po_number.touched || poFormGroup.controls.po_number.dirty)">
          @if (poFormGroup.controls.po_number.errors?.required) {
            <p class="invalid-feedback">This field is
            required.</p>
          }
          @if (poFormGroup.controls.po_number.errors?.invalidFormat) {
            <p
              class="invalid-feedback">{{ this.ifeFormat.po_pattern.pattern_description }} Each track adds '/[album]' to
            this name.</p>
          }
          @if (!poFormGroup.controls.po_number.errors) {
            <p class="valid-feedback">The encoding PO number for later
            reference</p>
          }
        </div>
        <div class="col-4">
          <label for="email_notification" class="form-label">Email Notification</label>
          <input id="email_notification" type="text" formControlName="email_notification" [class.invalid]="poFormGroup.controls.email_notification.invalid && (poFormGroup.controls.email_notification.touched || poFormGroup.controls.email_notification.dirty)">
          @if (poFormGroup.controls.email_notification.errors?.required) {
            <p class="invalid-feedback">This field is
            required.</p>
          }
          @if (poFormGroup.controls.email_notification.errors?.email) {
            <p class="invalid-feedback">Please insert a
              valid
            email.</p>
          }
          @if (!poFormGroup.controls.email_notification.errors) {
            <p class="valid-feedback">A notification email will be
            sent to this address</p>
          }
        </div>
        <div class="col-4">
          <label for="email_notification_publish" class="form-label">Publish Notification Email</label>
          <input id="email_notification_publish" type="text" formControlName="email_notification_publish" [class.invalid]="poFormGroup.controls.email_notification_publish.invalid && (poFormGroup.controls.email_notification_publish.touched || poFormGroup.controls.email_notification_publish.dirty)">
          @if (poFormGroup.controls.email_notification_publish.errors?.email) {
            <p class="invalid-feedback">Please insert a valid
            email.</p>
          }
          @if (!poFormGroup.controls.email_notification_publish.errors) {
            <p class="valid-feedback">Receives delivery report on
            publish success</p>
          }
        </div>
        <div class="col-4 ">
          <label for="ife" class="form-label">IFE System<span class="required">*</span></label>
          <select id="ife" class="form-select" formControlName="ife" [compareWith]="compare_item_id_system" [class.invalid]="poFormGroup.controls.ife.invalid && (poFormGroup.controls.ife.touched || poFormGroup.controls.ife.dirty)">
            @for (sys of availableSystems; track sys.item_id) {
              <option [disabled]="sys.formats.length == 0"
                [ngValue]="sys"> {{ sys.item_text }}
              </option>
            }
          </select>
          @if (poFormGroup.controls.ife.errors?.required) {
            <p class="invalid-feedback">This field is required.</p>
          }
          @if (!poFormGroup.controls.ife.errors) {
            <p class="valid-feedback">Select the IFE system.</p>
          }

        </div>

        <div class="col-4 ">
          <label for="ife_format" class="form-label">IFE Format<span class="required">*</span></label>
          <select id="ife_format" class="form-select" formControlName="ife_format" [compareWith]="compare_item_id_format" [class.invalid]="poFormGroup.controls.ife_format.invalid && (poFormGroup.controls.ife_format.touched || poFormGroup.controls.ife_format.dirty)">
            @for (format of ifeFormats; track format.item_id) {
              <option [ngValue]="format">
                @if (format.audio_only) {
                  🎧
                } @else {
                  🎥
                }

                {{ format.item_text }}
              </option>
            }
          </select>
          @if (poFormGroup.controls.ife_format.errors?.required) {
            <p class="invalid-feedback">This field is
            required.</p>
          }
          @if (!poFormGroup.controls.ife_format.errors) {
            <p class="valid-feedback">Select the desired format.</p>
          }
        </div>

        <div class="col-4 ">
          <label for="po_destination" class="form-label">Delivery Destination<span class="required">*</span></label>
          <select id="po_destination" class="form-select" formControlName="po_destination"
            [compareWith]="compare_destination_id" [class.invalid]="poFormGroup.controls.po_destination.invalid && (poFormGroup.controls.po_destination.touched || poFormGroup.controls.po_destination.dirty)"  >
            @for (sys of poDestinations; track sys.destination_id) {
              <option [ngValue]="sys"
                [disabled]="sys.enabled == false ">{{ sys.display_name }}
              </option>
            }
          </select>
          @if (poFormGroup.controls.po_destination.errors?.required) {
            <p class="invalid-feedback">This field is
            required.</p>
          }
          @if (!poFormGroup.controls.po_destination.errors) {
            <p class="valid-feedback">Select the desired
            destination.</p>
          }
        </div>

        <div class="col-4 ">
          <label for="auto_publish" class="form-label">Publication</label>
          <select id="auto_publish" class="form-select" formControlName="auto_publish">
            <option [value]="true"> Automatic Publication
            </option>
            <option [value]="false"> Manual Publication
            </option>
          </select>
          <p class="valid-feedback">Manual Publication allows for a final QA step before distributing the content,
            whereas
          Automatic Publication releases the content immediately upon readiness.</p>
        </div>
        <div class="col-4 ">
          <label for="idType" class="form-label">Identifier type</label>
          <select id="idType" class="form-select" formControlName="idType">
            <option [value]="'isrc'">ISRC
            </option>
            <option [value]="'s3'">S3
            </option>
          </select>
          <p class="valid-feedback">Select identifier type.</p>
        </div>
      </div>

      <div class="row cl-spacing-box-huge">
        <div class="col-12"><h2>Tracks</h2></div>
      </div>

      <div class="row" formArrayName="poItems">
        <p class="alert cl-alert-warning">
          For Safran: The album name must match the ZIP archive name of the album, without the .zip suffix.
        </p>
        <p class="alert cl-alert-warning">
          For Thales: The album name must match the directory name assigned to the album.
        </p>
        <p class="alert cl-alert-info">
          All others: The album name is a free text field used to group titles that belong to the same album.
        </p>

        @for (item of poItems.controls; track item; let i = $index; let last = $last) {
          <div class="col-12" style="padding-top: 16px"
            [formGroupName]="i">
            <div style="display: flex; gap: 8px">
              <div>
                <input type="text"
                  disabled
                  value="{{ (i + 1) < 10 ? '000' : (i + 1) < 100 ? '00' : (i + 1) < 1000 ? '0' : '' }}{{ (i + 1) }}"
                  style="width: 60px"
                  >
              </div>
              <div style="flex-grow: 1; ">
                <input (paste)="onPaste($event, i)"
                  type="text"
                  formControlName="album"
                  placeholder="Album Name"
                  (input)="onInputChange(i)"
                  [class.invalid]="poItems.controls[i].controls['album'].invalid && (poItems.controls[i].controls['album'].touched || poItems.controls[i].controls['album'].dirty)"
                  />
                @if (poItems.controls[i].controls['album'].errors?.maxPoNameLengthValidator; as tooLong) {
                  <p class="invalid-feedback">Airline + PO prefix + album name is too long: the PO name
                    has {{ tooLong.actual }} characters, the encoder accepts at most {{ tooLong.max }}.</p>
                }
                @if (poItems.controls[i].controls['album'].errors?.s3TagValueTooLong; as tooLong) {
                  <p class="invalid-feedback">Airline + PO number + album name is too long: it encodes
                    to {{ tooLong.encoded }} of at most {{ tooLong.max }} characters. Characters
                    outside <code>A-Z a-z 0-9 + - = . _ :</code> need three characters each when
                    encoded.</p>
                }
                @if (last) {
                  <p class="valid-feedback">The album (or playlist) name groups tracks</p>
                }
              </div>
              <div style="flex-grow: 1; ">
                <input
                  type="text"
                  formControlName="name"
                  placeholder="Track Name"
                  (input)="onInputChange(i)"
                  [class.invalid]="poItems.controls[i].controls['name'].invalid && (poItems.controls[i].controls['name'].touched || poItems.controls[i].controls['name'].dirty)"
                  />
                @if (poItems.controls[i].controls['name'].errors?.s3TagValueTooLong; as tooLong) {
                  <p class="invalid-feedback">The track name is too long: it encodes to
                    {{ tooLong.encoded }} of at most {{ tooLong.max }} characters. Characters outside
                    <code>A-Z a-z 0-9 + - = . _ :</code> need three characters each when encoded.</p>
                }
                @if (last) {
                  <p class="valid-feedback">The track's name human readable</p>
                }
              </div>
              <div style="flex-grow: 1; ">
                <input
                  type="text"
                  formControlName="id"
                  placeholder="Track Identifier"
                  (input)="onInputChange(i)"
                  [class.invalid]="poItems.controls[i].controls['id'].invalid && (poItems.controls[i].controls['id'].touched || poItems.controls[i].controls['id'].dirty)"
                  />
                @if (poItems.controls[i].controls['id'].errors?.notUnique) {
                  <p class="invalid-feedback">Tracks {{ poItems.controls[i].controls['id'].errors?.notUnique }} are
                  requesting the same identifier</p>
                }
                @if (poItems.controls[i].controls['id'].errors?.pattern) {
                  <p class="invalid-feedback">Invalid {{ poFormGroup.controls['idType'].value }} identifier</p>
                }
                @if (last) {
                  <p class="valid-feedback">The isrc identifies the physical track in the album or s3 url pointing to the
                  source</p>
                }
              </div>
              <div style="flex-grow: 1;">
                <input
                  type="text"
                  formControlName="filename"
                  placeholder="Output Filename"
                  (input)="onInputChange(i)"
                  />
                @if (last) {
                  <p class="valid-feedback">Output filename as in the load sheet</p>
                }
              </div>
              <div>
                @if (poItems.controls[i].value['submitted']) {
                  <i class="fas fa-check"></i>
                }
              </div>
            </div>
          </div>
        }


      </div>


      <div class="row cl-spacing-small">

        <div class="col-12">
          <app-form-footer #footer="formFooter" label="Start encode" icon="play" (action)="submitPo($event)">
            <button footerStart (click)="reset(footer.button)" type="button" class="btn cl-color-tertiary"><span>Reset</span><i
              class="fas fa-undo-alt" aria-hidden="true"></i></button>
            @if (started) {
              <button footerStart type="button" class="btn cl-color-tertiary" (click)="openAll()">Open POs</button>
            }
          </app-form-footer>
        </div>
      </div>
    </div>

  </section>

</main>
